const API_VER = 'v1.0'
export const CisEndpoints = {
  CIS_COUNTRY_GET_COUNTRY_LIST: `/cis/api/${API_VER}/country/get_country_list/`,
  CIS_COUNTRY_GET_COUNTRY_STATE: `/cis/api/${API_VER}/country/get_country_state/`,
}
